import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import styles from './DashboardHeader.module.css';
import Button from '../../components/Button/Button';
import buttonStyles from '../../components/Button/Button.module.css';

const DashboardHeader = () => {
    const navigate = useNavigate();

    const handleLogout = async () => {
    try {
        const token = localStorage.getItem('access_token'); // Assuming the token is stored here
        if (!token) {
        // nothing to send — just navigate / or clear and return
        localStorage.removeItem("access_token");
        navigate("/");
        return;
        } 
        const response = await fetch('https://377storage.vip/api/signout', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,  // Pass the token for authentication
            },
        });

        if (response.ok) {
            localStorage.removeItem("access_token")
            navigate('/');  // On successful logout
        } else {
            const errorData = await response.json();
        }
    } catch (error) {
        console.error('Error during logout:', error);;
    }
};

/////////////////////////////////////////////////////////////
  return (
    <header className={styles.flex}>
        <img src='/images/377StorageLogo.jpeg' alt='377 Storage Logo' className={styles.logo}/>
        <h1 className={styles.title}>~ 377 Storage ~</h1>
        <Button className={buttonStyles.logout} onClick={handleLogout}>Logout</Button>
    </header>

);
};

export default DashboardHeader;